module.exports = __webpack_public_path__ + "img/syimg5.34f0836d.png";